/**
 * Liffner PDP Image Indicator
 * gap:0 so inactive segments merge into one continuous line
 */
(function LiffnerPDPIndicator() {
  'use strict';

  var STYLES = [
    '.lsw-pdp-wrap { position: relative; }',
    '.lsw-pdp-lines {',
    '  display: flex;',
    '  gap: 0;',
    '  position: absolute;',
    '  bottom: 0;',
    '  left: 0;',
    '  right: 0;',
    '  z-index: 20;',
    '  pointer-events: none;',
    '}',
    '.lsw-pdp-line {',
    '  flex: 1;',
    '  height: 2px;',
    '  background: rgba(0,0,0,0.15);',
    '  transition: background 0.25s ease;',
    '}',
    '.lsw-pdp-line.is-active { background: rgba(0,0,0,0.65); }',
    '@media (hover: hover) and (pointer: fine) {',
    '  .lsw-pdp-lines { display: none; }',
    '}',
  ].join('\n');

  function injectStyles() {
    if (document.getElementById('lsw-pdp-styles')) return;
    var el = document.createElement('style');
    el.id = 'lsw-pdp-styles'; el.textContent = STYLES;
    document.head.appendChild(el);
  }

  function buildIndicator(sliderEl, count) {
    sliderEl.classList.add('lsw-pdp-wrap');
    var bar = document.createElement('div');
    bar.className = 'lsw-pdp-lines';
    var lines = [];
    for (var i = 0; i < count; i++) {
      var line = document.createElement('div');
      line.className = 'lsw-pdp-line' + (i === 0 ? ' is-active' : '');
      bar.appendChild(line);
      lines.push(line);
    }
    sliderEl.appendChild(bar);
    return function(idx) {
      lines.forEach(function(l, i) { l.classList.toggle('is-active', i === idx); });
    };
  }

  function init() {
    var slider = document.querySelector('.vertical-slider-for');
    if (!slider) return;
    injectStyles();
    var attempts = 0;
    var poll = setInterval(function() {
      if (++attempts > 60) { clearInterval(poll); return; }
      if (!slider.classList.contains('slick-initialized')) return;
      clearInterval(poll);
      var count = slider.querySelectorAll('.slick-slide:not(.slick-cloned)').length;
      if (count < 2) return;
      var update = buildIndicator(slider, count);
      if (window.jQuery) {
        jQuery(slider).on('afterChange', function(e, slick, idx) { update(idx); });
      }
    }, 100);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else { init(); }

})();
